import Echo from "laravel-echo";
import pusher from "pusher-js";
import io from "socket.io-client";

declare global {
  interface Window {
    io: any;
    Echo: Echo;
    pusher: any;
  }
}

window.io = io;
window.pusher = pusher;
export function createSocketConnection() {
  if (!window.Echo) {
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: process.env.REACT_APP_WEBSOCKET_KEY,
      cluster: process.env.REACT_APP_WEBSOCKET_CLUSTER,
      wsHost: process.env.REACT_APP_WEBSOCKET_URL,
      forceTLS: false,
      wsPort: process.env.REACT_APP_WEBSOCKET_PORT,
      wssPort: process.env.REACT_APP_WEBSOCKET_PORT,
      encrypted: false,
      transports: ['websocket', 'polling', 'flashsocket'],
      enabledTransports: ['ws', 'wss'],
    });
  }
}
